import { useCreate } from '../../../../../../../api/react-query';
import { useTranslate } from '../../../../../../../hooks';

export function useSwapShift() {
  const { translate } = useTranslate();

  const { mutateAsync, isLoading } = useCreate({
    url: 'shift-management/employees/shift-patterns/assigned/swap',
    msg: `${translate('Swapped Successfully!')}`,
  });

  return {
    isLoading,
    swapShift: mutateAsync,
  };
}
